import React from 'react';
import { FormattedElements } from './elements/FormattedElements';
import { FiShoppingBag } from 'react-icons/fi';

interface ChatMessageProps {
  message: any;
  onProductClick: (productId: number) => void;
  onSendMessage?: (message: string) => void;
  isLastAgentMessage?: boolean;
  agent_chat_id?: number;
}

export const ChatMessage: React.FC<ChatMessageProps> = ({ 
  message, 
  onProductClick,
  onSendMessage,
  isLastAgentMessage = false,
  agent_chat_id
}) => {
  const isSending = message.isSending || false;
  
  if (message.type === 'user') {
    return (
      <div className="mb-6 flex justify-start">
        <div className="max-w-[88%] app-sm:max-w-[72%]">
          <div className={`rounded-[14px_14px_4px_14px] border border-ds-primary-ring bg-ds-primary-soft px-3.5 py-2.5 text-[13px] leading-[1.9] text-ds-900 ${isSending ? 'opacity-60' : ''}`}>
            <p className="m-0 whitespace-pre-wrap">{message.content}</p>
          </div>
          {!isSending && (
            <p className="mt-1.5 text-[9px] text-ds-500">
              {new Date(message.created_at).toLocaleTimeString('fa-IR', { hour: '2-digit', minute: '2-digit' })}
            </p>
          )}
        </div>
      </div>
    );
  }
  
  if (message.type === 'agent') {
    return (
      <div className="mb-[30px] grid grid-cols-[30px_minmax(0,1fr)] gap-2 app-sm:grid-cols-[36px_minmax(0,1fr)] app-sm:gap-3">
        <div className="relative grid h-[30px] w-[30px] place-items-center rounded-ds-8 border border-ds-100 bg-ds-white text-ds-navy app-sm:h-9 app-sm:w-9" aria-hidden="true">
          <FiShoppingBag size={16} />
          <i className="absolute left-[5px] top-[5px] h-1 w-1 rounded-full bg-ds-primary" />
        </div>
        <div className="min-w-0">
          <div className="mb-2 flex items-center gap-2 text-[11px] text-ds-600">
            <strong>دستیار باسلام</strong>
            <span className="text-ds-400">همراه خرید</span>
          </div>
          <div className="min-w-0">
            <FormattedElements elements={message.elements} onProductClick={onProductClick} onSendMessage={onSendMessage} isLastAgentMessage={isLastAgentMessage} agent_chat_id={agent_chat_id} />
          </div>
          <p className="mt-2 text-[9px] text-ds-500">
            {new Date(message.created_at).toLocaleTimeString('fa-IR', { hour: '2-digit', minute: '2-digit' })}
          </p>
        </div>
      </div>
    );
  }
  
  if (message.type === 'system') {
    return (
      <div className="my-5 text-center">
        <p className="inline-block rounded-full bg-ds-subtle px-3 py-1.5 text-[10px] text-ds-500">{message.content}</p>
      </div>
    );
  }
  
  return null;
};
